/* Mobile menu burger toggle */
(function () {
    /*====================================================
      Shared UI Helpers
    ====================================================*/
    window.gotixi = window.gotixi || {};
    var signupPromise = null; // Global promise to track member creation

    window.gotixi.replaceFormWithSuccessMessage = function(formElement, type) {
        try {
            if (!formElement) {
                console.warn('[GoTixi] replaceFormWithSuccessMessage: No form element provided');
                return;
            }
            console.log('[GoTixi] Replacing form with success message. Type:', type || 'confirmed');
            
            var message = 'You are already subscribed to Gotixi.com! 🎉';
            if (type === 'pending') {
                message = 'You\'ve subscribed! 💌 Check your inbox to confirm.';
            }

            // Create the success message element
            var msgDiv = document.createElement('div');
            msgDiv.className = 'subscribed-persistent-message';
            msgDiv.innerHTML = '<div class="subscribed-persistent-message-inner">' + message + '</div>';
            
            var parent = formElement.parentElement;
            if (parent) {
                if (formElement.parentNode === parent) {
                    parent.replaceChild(msgDiv, formElement);
                } else {
                    parent.innerHTML = msgDiv.outerHTML;
                }
            } else {
                formElement.innerHTML = msgDiv.innerHTML;
            }
        } catch (e) {
            console.error('[GoTixi] UI Replacement failed:', e);
        }
    };

    window.gotixi.replaceFormsWithSubscribedMessage = function() {
        console.log('[GoTixi] Running global forms replacement');
        var type = 'confirmed';
        if (document.cookie.includes('gotixi_pending_sub=true')) {
            type = 'pending';
        }
        
        var forms = document.querySelectorAll('.gh-form[data-members-form], .gh-form[data-gotixi-form]');
        forms.forEach(function(form) {
            window.gotixi.replaceFormWithSuccessMessage(form, type);
        });
    };

    /*====================================================
      Check Subscribed Cookie on Page Load
    ====================================================*/
    if (document.cookie.includes('gotixi_subscribed=true') || document.cookie.includes('gotixi_pending_sub=true')) {
        if (window.gotixi && typeof window.gotixi.replaceFormsWithSubscribedMessage === 'function') {
            window.gotixi.replaceFormsWithSubscribedMessage();
        }
        document.addEventListener('DOMContentLoaded', function() {
            if (window.gotixi && typeof window.gotixi.replaceFormsWithSubscribedMessage === 'function') {
                window.gotixi.replaceFormsWithSubscribedMessage();
            }
        });
    }


    /*====================================================
      Ghost default logic
    ====================================================*/
    const navigation = document.querySelector('.gh-navigation');
    if (!navigation) return; // The shared premium header owns its own interactions.
    const burger = navigation.querySelector('.gh-burger');
    const backdrop = navigation.querySelector('.gh-mobile-backdrop');
    if (!burger) return;

    function toggleMenu() {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = '';
        }
    }

    burger.addEventListener('click', toggleMenu);

    /* Close menu and trigger lead form on CTA click */
    const ctaButton = document.getElementById('start-journey-cta');
    if (ctaButton) {
        ctaButton.addEventListener('click', function() {
            window.dispatchEvent(new CustomEvent('open-lead-form'));
            if (navigation.classList.contains('is-open')) {
                toggleMenu();
            }
        });
    }

    if (backdrop) {
        backdrop.addEventListener('click', function() {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = '';
        });
    }

})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* dropdown() also flips .is-dropdown-loaded on .gh-navigation, which is what
   takes the top-level nav items out of their default `opacity:0` (see
   screen.css ".gh-navigation:not(.is-dropdown-loaded) .nav>li") — so it must
   still run. The "collapse into a ..." part of it is disabled inside
   dropdown.js itself; see the comment there for why. */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* Subscription Q&A modal — intercepts subscribe, shows Q&A first, injects Ghost labels */
(function () {
    var overlay = document.getElementById('interests-modal-overlay');
    if (!overlay) return;

    var container = document.getElementById('interests-modal-container');
    var step = 0; // 0 = Loading -> Subscribed, 1 = Q1/Q2, 2 = Name, 3 = Submitting
    var answers = { origin_city: '', products: [], name: '' };
    var pendingForm = null;
    var savedFormHTML = '';
    var emailValue = '';

    function buildLabelArray() {
        var labels = [];
        if (answers.origin_city) {
            if (Array.isArray(answers.origin_city)) {
                answers.origin_city.forEach(function (city) {
                    labels.push({ name: 'origin-' + city.toLowerCase().replace(/\s+/g, '-') });
                });
            } else {
                labels.push({ name: 'origin-' + answers.origin_city.toLowerCase().replace(/\s+/g, '-') });
            }
        }
        if (answers.products) {
            if (Array.isArray(answers.products)) {
                answers.products.forEach(function (p) {
                    labels.push({ name: 'interest-' + p.toLowerCase().replace(/\s+/g, '-') });
                });
            } else if (typeof answers.products === 'string') {
                labels.push({ name: 'interest-' + answers.products.toLowerCase().replace(/\s+/g, '-') });
            }
        }
        if (answers.name) {
            labels.push({ name: 'name-' + answers.name.toLowerCase().replace(/\s+/g, '-') });
        }
        return labels;
    }

    function typeEffect(element, text, speed, callback) {
        element.innerHTML = '<span class="ai-cursor inline-block w-[3px] h-[1em] bg-current align-middle ml-1 animate-[pulse_1s_ease-in-out_infinite]"></span>';
        let cursor = element.querySelector('.ai-cursor');
        let i = 0;
        function typeChar() {
            if (i < text.length) {
                let charNode = document.createTextNode(text.charAt(i));
                element.insertBefore(charNode, cursor);
                i++;
                setTimeout(typeChar, speed + (Math.random() * 20));
            } else {
                if (cursor) cursor.remove();
                if (callback) callback();
            }
        }
        setTimeout(typeChar, 300);
    }

    function openModal(form) {
        if (document.cookie.includes('gotixi_subscribed=true')) {
            console.log('[GoTixi] Modal open blocked: User already subscribed');
            return;
        }

        var emailInput = form.querySelector('input[type="email"]');
        emailValue = emailInput ? emailInput.value : '';

        pendingForm = form;
        savedFormHTML = form.innerHTML;
        
        overlay.classList.remove('hidden');
        setTimeout(function() {
            overlay.classList.add('is-visible');
        }, 10);
        
        document.body.style.overflow = 'hidden';

        var clonedForm = form.cloneNode(true);
        clonedForm.removeAttribute('data-members-form');
        form.parentNode.replaceChild(clonedForm, form);
        pendingForm = clonedForm;
        
        step = 0;
        answers = { origin_city: '', products: [], name: '' };
        renderStep();
    }

    function closeModal() {
        overlay.classList.remove('is-visible');
        document.body.style.overflow = '';
        
        setTimeout(function() {
            overlay.classList.add('hidden');
            container.innerHTML = '';
        }, 300);
        
        if (pendingForm && savedFormHTML) {
            pendingForm.innerHTML = savedFormHTML;
            pendingForm.setAttribute('data-members-form', '');
        }
        pendingForm = null;
        savedFormHTML = '';
    }

    function renderStep() {
        if (step === 0) {
            // Loading -> Success Screen 
            container.innerHTML = `
<div class="flex flex-1 justify-center items-center py-10 px-6 z-10 w-full min-h-screen">
<div class="max-w-[400px] w-full flex flex-col space-y-6 items-center text-center opacity-0 transition-opacity duration-500" id="step0-loading">
<div class="animate-spin inline-flex items-center justify-center w-16 h-16 rounded-full border-4 border-primary/20 border-t-primary mb-2"></div>
<h2 class="text-slate-900 dark:text-slate-100 font-display text-3xl font-bold leading-tight">Checking your subscription...</h2>
</div>
<div class="max-w-[400px] w-full flex flex-col space-y-8 items-center text-center hidden opacity-0 transition-opacity duration-500" id="step0-success">
<div class="inline-flex items-center justify-center w-20 h-20 rounded-full bg-primary/10 text-primary mb-2">
<span class="material-symbols-outlined text-4xl" style="font-variation-settings: 'FILL' 1;">check_circle</span>
</div>
<h2 class="text-slate-900 dark:text-slate-100 font-display text-4xl font-bold leading-tight">You're subscribed!</h2>
</div>
</div>`;
            
            setTimeout(() => {
                let loading = document.getElementById('step0-loading');
                if (loading) loading.classList.remove('opacity-0');
            }, 50);

            // Wait 1.5s then show success, then wait 1.5s then go to Q1
            setTimeout(() => {
                let loading = document.getElementById('step0-loading');
                let success = document.getElementById('step0-success');
                if (loading && success) {
                    loading.classList.add('opacity-0');
                    setTimeout(() => {
                        loading.classList.add('hidden');
                        success.classList.remove('hidden');
                        setTimeout(() => success.classList.remove('opacity-0'), 50);
                        
                        setTimeout(() => {
                            success.classList.add('opacity-0');
                            setTimeout(() => {
                                step = 1;
                                renderStep();
                            }, 500);
                        }, 2000);
                    }, 500);
                }
            }, 1500);


        } else if (step === 1) {
            container.innerHTML = `
<div class="flex flex-1 justify-center items-center py-10 px-6 z-10 w-full min-h-screen opacity-0 transition-opacity duration-500" id="step1-wrapper">
<div class="max-w-[560px] w-full flex flex-col space-y-6">
<div class="max-w-[560px] w-full flex flex-col space-y-6">
<!-- Header Section -->
<div class="flex items-start gap-4">
<h1 id="step1-header" class="text-slate-900 dark:text-slate-100 font-display text-4xl font-bold leading-tight min-h-[80px] md:min-h-[96px] pt-1">
</h1>
</div>
<!-- Form Section -->
<div class="space-y-10">
<!-- Question 1: Location -->
<div class="space-y-4 hidden" id="q1-container">
<div class="flex items-center gap-3" id="q1-title-container">
<span class="material-symbols-outlined text-primary text-3xl" style="font-variation-settings: 'FILL' 1;">location_on</span>
<h2 class="text-slate-900 dark:text-slate-100 text-2xl font-bold font-display" id="q1-title"></h2>
</div>
<div class="flex gap-4 flex-wrap hidden opacity-0 transition-opacity duration-500" id="location-options">
    <button type="button" class="location-btn flex h-14 items-center justify-center rounded-2xl bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 px-8 transition-all hover:border-primary/50 text-slate-600 dark:text-slate-400 font-semibold text-lg" data-value="Mumbai">Mumbai</button>
    <button type="button" class="location-btn flex h-14 items-center justify-center rounded-2xl bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 px-8 transition-all hover:border-primary/50 text-slate-600 dark:text-slate-400 font-semibold text-lg" data-value="Delhi">Delhi</button>
    <button type="button" class="location-btn flex h-14 items-center justify-center rounded-2xl bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 px-8 transition-all hover:border-primary/50 text-slate-600 dark:text-slate-400 font-semibold text-lg" data-value="Bangalore">Bangalore</button>
    <button type="button" class="location-btn flex h-14 items-center justify-center rounded-2xl bg-slate-50 dark:bg-slate-700/50 border-2 border-dashed border-slate-300 dark:border-slate-600 px-8 transition-all hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-500 dark:text-slate-400 font-semibold text-lg" data-value="Other">+ Other</button>
</div>
<div id="other-location-wrap" class="hidden mt-4 opacity-0 transition-opacity duration-500 flex gap-2 w-full max-w-sm">
    <input type="text" id="other-location-input" class="flex-1 flex border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 rounded-xl h-14 px-5 text-lg font-medium outline-none focus:outline-none focus:ring-0 transition-all text-slate-900 dark:text-slate-100 placeholder:text-slate-400" placeholder="Type your city..." autocomplete="off" />
    <button type="button" id="other-location-submit" class="bg-primary hover:bg-primary/90 text-white rounded-xl px-5 flex items-center justify-center transition-all h-14 group outline-none focus:outline-none focus:ring-0 border-none">
        <span class="material-symbols-outlined transition-transform group-hover:translate-x-1">arrow_forward</span>
    </button>
</div>
</div>
<!-- Question 2: Interests -->
<div class="space-y-4 hidden" id="q2-container">
<div class="flex items-center gap-3" id="q2-title-container">
<span class="material-symbols-outlined text-primary text-3xl" style="font-variation-settings: 'FILL' 1;">favorite</span>
<h2 class="text-slate-900 dark:text-slate-100 text-2xl font-bold font-display" id="q2-title"></h2>
</div>
<div class="grid gap-4 hidden opacity-0 transition-opacity duration-500" id="interest-options">
    <label class="q2-opt-label flex items-center justify-between p-6 rounded-2xl bg-white dark:bg-slate-800 border-2 border-slate-100 dark:border-slate-700 cursor-pointer group hover:border-primary/40 transition-all duration-700 ease-out opacity-0 translate-y-8 shadow-sm">
        <div class="flex flex-col min-h-[44px] justify-center">
          <span class="q2-opt-title text-slate-900 dark:text-slate-100 font-bold text-xl" data-text="Drops"></span>
          <span class="q2-opt-desc text-slate-500 dark:text-slate-400 text-base mt-1" data-text="Exclusive sales and early access"></span>
        </div>
        <!-- Toggle Switch UI -->
        <input type="checkbox" value="drops" class="interest-checkbox sr-only" checked/>
        <div class="toggle-bg flex w-14 h-8 bg-primary rounded-full items-center transition-all duration-300">
            <span class="toggle-dot w-6 h-6 bg-white rounded-full transition-all duration-300 shadow-sm translate-x-7"></span>
        </div>
    </label>
    <label class="q2-opt-label flex items-center justify-between p-6 rounded-2xl bg-white dark:bg-slate-800 border-2 border-slate-100 dark:border-slate-700 cursor-pointer group hover:border-primary/40 transition-all duration-700 ease-out opacity-0 translate-y-8 shadow-sm">
        <div class="flex flex-col min-h-[44px] justify-center">
          <span class="q2-opt-title text-slate-900 dark:text-slate-100 font-bold text-xl" data-text="Points"></span>
          <span class="q2-opt-desc text-slate-500 dark:text-slate-400 text-base mt-1" data-text="Maximize your loyalty rewards"></span>
        </div>
        <!-- Toggle Switch UI -->
        <input type="checkbox" value="points" class="interest-checkbox sr-only" checked/>
        <div class="toggle-bg flex w-14 h-8 bg-primary rounded-full items-center transition-all duration-300">
            <span class="toggle-dot w-6 h-6 bg-white rounded-full transition-all duration-300 shadow-sm translate-x-7"></span>
        </div>
    </label>
    <label class="q2-opt-label flex items-center justify-between p-6 rounded-2xl bg-white dark:bg-slate-800 border-2 border-slate-100 dark:border-slate-700 cursor-pointer group hover:border-primary/40 transition-all duration-700 ease-out opacity-0 translate-y-8 shadow-sm">
        <div class="flex flex-col min-h-[44px] justify-center">
          <span class="q2-opt-title text-slate-900 dark:text-slate-100 font-bold text-xl" data-text="Trips"></span>
          <span class="q2-opt-desc text-slate-500 dark:text-slate-400 text-base mt-1" data-text="Expertly curated itineraries"></span>
        </div>
        <!-- Toggle Switch UI -->
        <input type="checkbox" value="trips" class="interest-checkbox sr-only" checked/>
        <div class="toggle-bg flex w-14 h-8 bg-primary rounded-full items-center transition-all duration-300">
            <span class="toggle-dot w-6 h-6 bg-white rounded-full transition-all duration-300 shadow-sm translate-x-7"></span>
        </div>
    </label>
</div>
</div>
</div>
<!-- Footer Buttons -->
<div class="flex flex-col space-y-4 pt-6 hidden opacity-0 transition-opacity duration-500 items-center w-full" id="step1-footer">
<button type="button" id="step1-continue" class="w-full border-none outline-none bg-primary hover:bg-primary/90 text-white font-bold py-4 rounded-xl shadow-lg shadow-primary/20 transition-all active:scale-[0.98] text-2xl h-16">
    Continue
</button>
<button type="button" id="step1-skip" class="w-fit border-none outline-none bg-transparent hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-500 dark:text-slate-400 font-medium py-3 px-8 rounded-xl transition-all text-lg">
    Skip for now
</button>
</div>
</div>
</div>`;
            
            setTimeout(() => {
                let wrapper = document.getElementById('step1-wrapper');
                if (wrapper) wrapper.classList.remove('opacity-0');
            }, 50);

            // Animation sequence
            setTimeout(() => {
                typeEffect(document.getElementById('step1-header'), "To get started, tell me a bit about your travel style...", 30, function() {
                    document.getElementById('q1-container').classList.remove('hidden');
                    typeEffect(document.getElementById('q1-title'), "Where are you based?", 30, function() {
                        let opts = document.getElementById('location-options');
                        opts.classList.remove('hidden');
                        setTimeout(() => opts.classList.remove('opacity-0'), 50);
                    });
                });
            }, 300);

            bindStep1();

        } else if (step === 2) {
            container.innerHTML = `
<div class="layout-container flex h-full grow flex-col z-10 w-full min-h-screen opacity-0 transition-opacity duration-500" id="step2-wrapper">
<main class="flex-1 flex flex-col items-center justify-center px-6 py-12 lg:py-24">
<div class="w-full max-w-[560px] flex flex-col space-y-8">
<!-- Text Header Section -->
<div class="text-center space-y-1">
<h1 id="step2-header" class="text-slate-900 dark:text-slate-100 text-4xl md:text-5xl font-display font-black leading-tight tracking-tight min-h-[48px] md:min-h-[60px]"></h1>
<p id="step2-desc" class="text-slate-600 dark:text-slate-400 text-lg md:text-xl font-normal max-w-md mx-auto opacity-0 transition-opacity duration-500">
    We'd love to personalize your travel inspiration and address your weekly postcards.
</p>
</div>
<!-- Input Field Section -->
<div id="step2-input-section" class="space-y-3 hidden opacity-0 transition-opacity duration-500">
<label class="text-slate-900 dark:text-slate-100 text-sm font-display font-bold uppercase tracking-widest ml-1">Your Name</label>
<div class="relative group w-full">
<input id="step2-name-input" class="w-full flex border-2 border-primary/20 bg-white dark:bg-slate-800 rounded-xl h-20 px-8 text-2xl font-display text-slate-900 dark:text-white focus:ring-4 focus:ring-primary/20 focus:border-primary transition-all placeholder:text-slate-300 dark:placeholder:text-slate-600 outline-none" placeholder="Enter your name" type="text" autocomplete="off"/>
</div>
</div>
<!-- Info Note -->
<div id="step2-note" class="flex items-center gap-3 p-5 rounded-xl bg-primary/5 border border-primary/10 hidden opacity-0 transition-opacity duration-500">
<span class="material-symbols-outlined text-primary text-xl flex-shrink-0" style="font-variation-settings: 'FILL' 1;">verified_user</span>
<p class="text-slate-600 dark:text-slate-400 text-sm leading-relaxed">
    This is how you'll appear in our community of 50,000+ wanderers. You can always change this later in your profile settings.
</p>
</div>
</div>
</main>
<!-- Sticky Bottom Action Bar -->
<footer id="step2-footer" class="mt-auto border-t border-primary/10 bg-transparent p-6 pb-12 lg:px-20 mx-auto w-full hidden opacity-0 transition-opacity duration-500">
<div class="max-w-[560px] mx-auto w-full flex flex-col sm:flex-row items-center gap-4">
<button type="button" id="step2-skip" class="w-full sm:flex-1 border-none outline-none bg-transparent hover:bg-slate-200 dark:hover:bg-slate-800 text-slate-500 dark:text-slate-400 font-medium py-3 rounded-xl transition-all h-16 text-xl">
    Skip
</button>
<button type="button" id="step2-continue" class="w-full sm:flex-1 flex cursor-pointer items-center justify-center rounded-xl border-none outline-none h-16 bg-primary hover:bg-primary/90 text-white text-2xl font-bold tracking-wide transition-all shadow-lg shadow-primary/20 active:scale-[0.98]">
<span>Let's go</span>
<span class="material-symbols-outlined ml-2 text-2xl">east</span>
</button>
</div>
</footer>
</div>`;
            
            setTimeout(() => {
                let wrapper = document.getElementById('step2-wrapper');
                if (wrapper) wrapper.classList.remove('opacity-0');
            }, 50);

            setTimeout(() => {
                typeEffect(document.getElementById('step2-header'), "What should we call you?", 35, function() {
                    document.getElementById('step2-desc').classList.remove('opacity-0');
                    
                    let inputSec = document.getElementById('step2-input-section');
                    let note = document.getElementById('step2-note');
                    let footer = document.getElementById('step2-footer');
                    
                    inputSec.classList.remove('hidden');
                    note.classList.remove('hidden');
                    footer.classList.remove('hidden');
                    
                    setTimeout(() => {
                        inputSec.classList.remove('opacity-0');
                        note.classList.remove('opacity-0');
                        footer.classList.remove('opacity-0');
                        document.getElementById('step2-name-input').focus();
                    }, 50);
                });
            }, 300);

            bindStep2();

        } else {
            submitWithLabels();
        }
    }

    function bindStep1() {
        var locationWrap = document.getElementById('location-options');
        var otherWrap = document.getElementById('other-location-wrap');
        var otherInput = document.getElementById('other-location-input');
        var otherSubmit = document.getElementById('other-location-submit');
        var q2Revealed = false;

        // Custom Toggle switch logic
        var interestCheckboxes = document.querySelectorAll('.interest-checkbox');
        interestCheckboxes.forEach(function(cb) {
            cb.addEventListener('change', function(e) {
                var toggleBg = this.nextElementSibling;
                var toggleDot = toggleBg.querySelector('.toggle-dot');
                if (this.checked) {
                    toggleBg.classList.add('bg-primary');
                    toggleBg.classList.remove('bg-slate-200', 'dark:bg-slate-600');
                    toggleDot.classList.add('translate-x-7');
                    toggleDot.classList.remove('translate-x-1');
                } else {
                    toggleBg.classList.remove('bg-primary');
                    toggleBg.classList.add('bg-slate-200', 'dark:bg-slate-600');
                    toggleDot.classList.remove('translate-x-7');
                    toggleDot.classList.add('translate-x-1');
                }
            });
        });

        function revealQ2() {
            if (q2Revealed) return;
            q2Revealed = true;
            document.getElementById('q2-container').classList.remove('hidden');
            typeEffect(document.getElementById('q2-title'), "What interests you?", 30, function() {
                let opts = document.getElementById('interest-options');
                opts.classList.remove('hidden');
                setTimeout(() => opts.classList.remove('opacity-0'), 10);
                
                let optLabels = opts.querySelectorAll('.q2-opt-label');
                let index = 0;

                function revealNextOption() {
                    if (index >= optLabels.length) {
                        let footer = document.getElementById('step1-footer');
                        footer.classList.remove('hidden');
                        setTimeout(() => footer.classList.remove('opacity-0'), 50);
                        return;
                    }
                    let label = optLabels[index];
                    
                    let titleSpan = label.querySelector('.q2-opt-title');
                    let descSpan = label.querySelector('.q2-opt-desc');
                    
                    // Set content immediately instead of typing
                    titleSpan.innerText = titleSpan.getAttribute('data-text');
                    descSpan.innerText = descSpan.getAttribute('data-text');

                    // Trigger the fade/slide-up animation
                    setTimeout(() => {
                        label.classList.remove('opacity-0', 'translate-y-8');
                        index++;
                        setTimeout(revealNextOption, 250); // Delay between each box
                    }, 50);
                }

                revealNextOption();
            });
        }

        function selectLocationBtn(btn) {
            var allBtns = document.querySelectorAll('.location-btn');
            allBtns.forEach(function(b) {
                b.classList.remove('border-primary', 'text-slate-900', 'dark:text-slate-100');
                b.classList.add('border-slate-200', 'dark:border-slate-700', 'text-slate-600', 'dark:text-slate-400');
                b.style.boxShadow = ''; // Remove shadow
                
                if (b.getAttribute('data-value') === 'Other' && b !== btn) {
                    b.classList.add('border-dashed', 'border-slate-300', 'dark:border-slate-600', 'text-slate-500', 'dark:text-slate-400');
                    b.classList.remove('border-slate-200', 'dark:border-slate-700', 'text-slate-600');
                }
            });
            
            btn.classList.add('border-primary', 'text-slate-900', 'dark:text-slate-100');
            btn.classList.remove('border-slate-200', 'dark:border-slate-700', 'border-dashed', 'border-slate-300', 'dark:border-slate-600', 'text-slate-600', 'dark:text-slate-400', 'text-slate-500');
            btn.style.boxShadow = 'inset 0 0 0 1px #f48c25'; // Simulate thicker inner border using box-shadow inside styling to prevent layout shift
        }

        locationWrap.addEventListener('click', function(e) {
            var btn = e.target.closest('.location-btn');
            if (!btn) return;
            
            selectLocationBtn(btn);
            var val = btn.getAttribute('data-value');
            if (val === 'Other') {
                otherWrap.classList.remove('hidden');
                setTimeout(() => otherWrap.classList.remove('opacity-0'), 10);
                answers.origin_city = '';
                otherInput.focus();
            } else {
                otherWrap.classList.add('opacity-0');
                setTimeout(() => otherWrap.classList.add('hidden'), 500);
                answers.origin_city = val;
                revealQ2();
            }
        });

        function handleOtherSubmit() {
            var val = otherInput.value.trim();
            if (val !== '') {
                // Hide input and arrow
                otherWrap.classList.add('opacity-0');
                setTimeout(() => otherWrap.classList.add('hidden'), 500);

                var existingBtn = document.querySelector('.location-btn[data-value="' + val.replace(/"/g, '&quot;') + '"]');
                var newBtn;
                if (existingBtn) {
                    newBtn = existingBtn;
                } else {
                    newBtn = document.createElement('button');
                    newBtn.type = 'button';
                    newBtn.className = 'location-btn flex h-14 items-center justify-center rounded-2xl bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 px-8 transition-all hover:border-primary/50 text-slate-600 dark:text-slate-400 font-semibold text-lg';
                    newBtn.setAttribute('data-value', val);
                    newBtn.innerText = val;
                    
                    var otherBtn = document.querySelector('.location-btn[data-value="Other"]');
                    otherBtn.parentNode.insertBefore(newBtn, otherBtn);
                }
                
                selectLocationBtn(newBtn);
                answers.origin_city = val;
                otherInput.value = ''; // Reset the input box when closed
                revealQ2();
            }
        }

        if (otherSubmit) {
            otherSubmit.addEventListener('click', handleOtherSubmit);
        }

        if (otherInput) {
            otherInput.addEventListener('keydown', function(e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    handleOtherSubmit();
                }
            });
        }

        document.getElementById('step1-continue').addEventListener('click', function() {
            if (!q2Revealed) {
                revealQ2();
                return;
            }

            if (otherWrap && !otherWrap.classList.contains('hidden') && otherInput.value.trim() !== '') {
                answers.origin_city = otherInput.value.trim();
            }

            var checks = document.querySelectorAll('.interest-checkbox:checked');
            answers.products = [];
            checks.forEach(function(c) {
                answers.products.push(c.value);
            });

            // Fade out then re-render step 2
            let wrapper = document.getElementById('step1-wrapper');
            if (wrapper) wrapper.classList.add('opacity-0');
            setTimeout(() => {
                step = 2;
                renderStep();
            }, 500);
        });

        document.getElementById('step1-skip').addEventListener('click', function() {
            let wrapper = document.getElementById('step1-wrapper');
            if (wrapper) wrapper.classList.add('opacity-0');
            setTimeout(() => {
                step = 2;
                renderStep();
            }, 500);
        });
    }

    function bindStep2() {
        var nameInput = document.getElementById('step2-name-input');
        if (nameInput) {
            nameInput.addEventListener('keydown', function(e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    answers.name = nameInput.value.trim();
                    let wrapper = document.getElementById('step2-wrapper');
                    if (wrapper) wrapper.classList.add('opacity-0');
                    setTimeout(() => {
                        step = 3;
                        renderStep();
                    }, 500);
                }
            });
        }

        document.getElementById('step2-continue').addEventListener('click', function() {
            if (nameInput) answers.name = nameInput.value.trim();
            let wrapper = document.getElementById('step2-wrapper');
            if (wrapper) wrapper.classList.add('opacity-0');
            setTimeout(() => {
                step = 3;
                renderStep();
            }, 500);
        });

        document.getElementById('step2-skip').addEventListener('click', function() {
            let wrapper = document.getElementById('step2-wrapper');
            if (wrapper) wrapper.classList.add('opacity-0');
            setTimeout(() => {
                step = 3;
                renderStep();
            }, 500);
        });
    }

    function showFinalStatus(message) {
        // Set pending cookie
        document.cookie = "gotixi_pending_sub=true; max-age=2592000; path=/";
        // Trigger global replacement
        if (window.gotixi && typeof window.gotixi.replaceFormsWithSubscribedMessage === 'function') {
            window.gotixi.replaceFormsWithSubscribedMessage();
        }

        container.innerHTML = `
<div class="flex flex-1 justify-center items-center py-10 px-6 z-10 w-full min-h-screen">
<div class="max-w-[400px] w-full flex flex-col space-y-8 items-center text-center opacity-0 transition-opacity duration-500" id="step3-final">
<div class="inline-flex items-center justify-center w-20 h-20 rounded-full bg-primary/10 text-primary mb-2">
<span class="material-symbols-outlined text-4xl" style="font-variation-settings: 'FILL' 1;">check_circle</span>
</div>
<h2 class="text-slate-900 dark:text-slate-100 font-display text-3xl font-bold leading-tight">` + message + `</h2>
<button type="button" id="interests-modal-final-close" class="mt-4 w-full border-none outline-none bg-primary hover:bg-primary/90 text-white font-bold py-4 rounded-xl shadow-lg shadow-primary/20 transition-all active:scale-[0.98] text-2xl h-16 flex items-center justify-center">Close</button>
</div>
</div>`;
        setTimeout(() => {
            let finalEl = document.getElementById('step3-final');
            if (finalEl) finalEl.classList.remove('opacity-0');
        }, 50);
        
        document.getElementById('interests-modal-final-close').addEventListener('click', closeModal);
        setTimeout(function () { closeModal(); }, 8000);
    }

    function getMembersBasePath() {
        var hostname = window.location.hostname;
        var pathname = window.location.pathname || '';

        if ((hostname === 'gotixi.com' || hostname === 'www.gotixi.com') && pathname.indexOf('/guides') === 0) {
            return '/guides/members';
        }

        return '/members';
    }

    function getMembersApiPath(path) {
        var normalizedPath = path.charAt(0) === '/' ? path : '/' + path;
        return getMembersBasePath() + normalizedPath;
    }

    function submitWithLabels() {
        var labelsArray = buildLabelArray();
        console.log('[GoTixi] Labels to apply:', labelsArray);

        container.innerHTML = `
<div class="flex flex-1 justify-center items-center py-10 px-6 z-10 w-full min-h-screen">
<div class="max-w-[400px] w-full flex flex-col space-y-6 items-center text-center opacity-0 transition-opacity duration-500" id="step3-loading">
<div class="animate-spin inline-flex items-center justify-center w-16 h-16 rounded-full border-4 border-primary/20 border-t-primary mb-2"></div>
<h2 class="text-slate-900 dark:text-slate-100 font-display text-2xl font-bold leading-tight">Setting you up...</h2>
</div>
</div>`;
        
        setTimeout(() => {
            let st = document.getElementById('step3-loading');
            if (st) st.classList.remove('opacity-0');
        }, 50);

        if (pendingForm) {
            var email = emailValue;
            
            if (labelsArray.length === 0) {
                showFinalStatus("You're all set! Check your inbox");
                return;
            }

            console.log('[GoTixi] Calling gotixi-tagging for:', email, 'with labels:', labelsArray);
            
            var taggingRequest = function() {
                fetch(getMembersApiPath('/api/gotixi-tagging'), {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ email: email, labels: labelsArray })
                }).then(function (res) {
                    console.log('[GoTixi] tagging response status:', res.status);
                    if (res.ok) {
                        showFinalStatus("You're all set! Check your inbox");
                    } else {
                        showFinalStatus("You're all set! Check your inbox"); 
                    }
                }).catch(function (err) {
                    console.error('[GoTixi] label attachment error:', err);
                    showFinalStatus("You're all set! Check your inbox");
                });
            };

            if (typeof signupPromise !== 'undefined' && signupPromise) {
                signupPromise.then(function() {
                    setTimeout(taggingRequest, 500); 
                }).catch(function() {
                    taggingRequest();
                });
            } else {
                taggingRequest();
            }
        }
    }

    // Close on overlay click or Escape key
    overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
            closeModal();
        }
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-visible')) {
            closeModal();
        }
    });

    // ─── Intercept subscription form submit → show Q&A first ───────────────
    var subscriptionForms = document.querySelectorAll('.gh-form');
    subscriptionForms.forEach(function (ghForm) {
        if (ghForm.hasAttribute('data-members-form')) {
            var val = ghForm.getAttribute('data-members-form');
            ghForm.removeAttribute('data-members-form');
            ghForm.setAttribute('data-gotixi-form', val);

            var btn = ghForm.querySelector('button[type="submit"]');
            if (btn) {
                var newBtn = btn.cloneNode(true);
                btn.parentNode.replaceChild(newBtn, btn);
            }
        }
    });

    document.addEventListener('submit', function (e) {
        var form = e.target;
        if (form && form.classList.contains('gh-form') && (form.hasAttribute('data-gotixi-form') || form.hasAttribute('data-members-form'))) {
            if (form.dataset.gotixiChecked === 'true') {
                return;
            }

            e.preventDefault();
            e.stopImmediatePropagation();

            var emailInput = form.querySelector('input[type="email"]');
            if (!emailInput || !emailInput.value || emailInput.value.indexOf('@') === -1) {
                emailInput.focus();
                return;
            }

            var email = emailInput.value;
            var submitBtn = form.querySelector('button[type="submit"]');
            
            form.classList.add('loading');
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.style.opacity = '0.7';
            }

            fetch(getMembersApiPath('/api/check-subscriber'), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: email })
            }).then(function (res) {
                if (!res.ok) {
                    return { exists: false };
                }
                return res.json();
            }).then(function (data) {
                if (data && data.exists) {
                    document.cookie = "gotixi_subscribed=true; max-age=31536000; path=/";
                    if (window.gotixi && typeof window.gotixi.replaceFormsWithSubscribedMessage === 'function') {
                        window.gotixi.replaceFormsWithSubscribedMessage();
                    }
                    throw 'ALREADY_SUBSCRIBED';
                }

                signupPromise = fetch(getMembersApiPath('/api/send-magic-link/'), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-ghost-version': '5.0'
                    },
                    body: JSON.stringify({
                        email: email,
                        emailType: 'subscribe',
                        labels: [] 
                    })
                });

                signupPromise.then(function(res) {
                    form.classList.remove('error');
                    form.classList.add('success');
                    return res;
                });

                form.classList.remove('loading');
                if (submitBtn) {
                    submitBtn.style.opacity = '1';
                    submitBtn.disabled = false;
                }
                
                setTimeout(function() {
                    openModal(form);
                }, 1000);

            }).catch(function (err) {
                form.classList.remove('loading');
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.style.opacity = '1';
                }

                if (err === 'ALREADY_SUBSCRIBED') {
                    if (form && document.body.contains(form)) {
                        form.style.visibility = 'hidden';
                    }
                    return;
                }
                
                openModal(form);
            });
        }
    });
})();

/*====================================================
  Category Filter (Discover by Theme)
====================================================*/
(function () {
    document.addEventListener('DOMContentLoaded', function() {
        const filterBar = document.getElementById('topic-filter-bar');
        const postCards = Array.from(document.querySelectorAll('.gh-card[data-primary-tag]'));
        
        if (!filterBar || !postCards.length) return;

        // 1. Collect unique primary tags from visible posts
        const tagMap = new Map(); // slug -> name
        postCards.forEach(card => {
            const primarySlug = card.getAttribute('data-primary-tag');
            if (!primarySlug) return;

            if (!tagMap.has(primarySlug)) {
                const primaryTagElem = card.querySelector('.gh-card-tag');
                if (primaryTagElem) {
                    tagMap.set(primarySlug, primaryTagElem.textContent.trim());
                } else {
                    // Fallback to capitalized slug if element not found
                    const fallbackName = primarySlug.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
                    tagMap.set(primarySlug, fallbackName);
                }
            }
        });

        // 2. Generate and append buttons
        const sortedSlugs = Array.from(tagMap.keys()).sort((a, b) => tagMap.get(a).localeCompare(tagMap.get(b)));
        
        sortedSlugs.forEach(slug => {
            const name = tagMap.get(slug);
            const btn = document.createElement('button');
            btn.className = 'gh-topic-filter-btn';
            btn.setAttribute('data-filter', slug);
            btn.textContent = name;
            filterBar.appendChild(btn);
        });

        // 3. Handle filtering logic
        const allButtons = filterBar.querySelectorAll('.gh-topic-filter-btn');
        allButtons.forEach(button => {
            button.addEventListener('click', function() {
                const filter = this.getAttribute('data-filter');

                // Update active button state
                allButtons.forEach(btn => btn.classList.remove('is-active'));
                this.classList.add('is-active');

                // Filter cards
                postCards.forEach(card => {
                    const postPrimaryTag = card.getAttribute('data-primary-tag');
                    
                    if (filter === 'all' || postPrimaryTag === filter) {
                        card.style.display = 'block';
                    } else {
                        card.style.display = 'none';
                    }
                });
            });
        });
    });
})();

/* Global Sticky CTA logic */
(function () {
    const stickyCta = document.querySelector('.sticky-cta');
    if (!stickyCta) return;

    let lastScrollTop = 0;

    window.addEventListener('scroll', function () {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const docHeight = document.documentElement.scrollHeight;
        const winHeight = window.innerHeight;

        // Only show on mobile
        if (window.innerWidth >= 768) {
            stickyCta.classList.remove('is-visible');
            return;
        }

        // Show after 50% scroll depth
        const scrollPercent = (scrollTop / (docHeight - winHeight)) * 100;

        if (scrollPercent > 50) {
            // Auto-hide on upward scroll, show on downward scroll
            if (scrollTop > lastScrollTop) {
                stickyCta.classList.add('is-visible');
            } else {
                stickyCta.classList.remove('is-visible');
            }
        } else {
            stickyCta.classList.remove('is-visible');
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }, { passive: true });
})();
